import { Map as ImmutableMap } from 'immutable';
import React from 'react';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

import { useAppSelector } from 'hooks/redux';

import InvestmentTransactionEditFormProvider from './components/InvestmentTransactionEditFormProvider';
import LegacyInvestmentTransactionEditDialog from './legacy';
import type { InvestmentTransactionDialogTransaction, InvestmentTransactionEditDialogProps } from './types';

export const DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT = 'DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT';

export const openInvestmentTransactionEditDialogAction = (
  transaction: InvestmentTransactionDialogTransaction,
  { props, ...overrides }: { props?: Record<string, unknown> } & Record<string, unknown> = {},
) =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      id: 'investment-transaction-edit-dialog',
      type: DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT,
      allowNesting: true,
      props: ImmutableMap({ transaction, ...props }),
      ...overrides,
    }),
  );

function InvestmentTransactionEditDialog(props: InvestmentTransactionEditDialogProps): React.JSX.Element {
  const useNewDialog = useAppSelector((state) =>
    featureFlagsSelectors.getFeatureFlag(state, 'investTransactionEditDialogV2'),
  );
  return useNewDialog ? (
    <InvestmentTransactionEditFormProvider {...props} />
  ) : (
    <LegacyInvestmentTransactionEditDialog {...props} />
  );
}

InvestmentTransactionEditDialog.displayName = 'InvestmentTransactionEditDialog';

export default InvestmentTransactionEditDialog;
